import { seoForPath } from "./seo";

function setMeta(selector: string, attribute: "name" | "property", key: string, content: string): void {
  let element = document.head.querySelector<HTMLMetaElement>(selector);
  if (!element) {
    element = document.createElement("meta");
    element.setAttribute(attribute, key);
    document.head.append(element);
  }
  element.content = content;
}

export function applyDocumentSeo(path: string): void {
  const config = seoForPath(path);
  const image = config.image ?? "https://kleanbg.com/assets/umbrella-portrait.webp";
  document.title = config.title;
  setMeta('meta[name="description"]', "name", "description", config.description);
  setMeta('meta[name="robots"]', "name", "robots", config.robots ?? "index,follow");
  setMeta('meta[property="og:title"]', "property", "og:title", config.title);
  setMeta('meta[property="og:description"]', "property", "og:description", config.description);
  setMeta('meta[property="og:type"]', "property", "og:type", config.type ?? "website");
  setMeta('meta[property="og:url"]', "property", "og:url", config.canonical);
  setMeta('meta[property="og:image"]', "property", "og:image", image);
  setMeta('meta[name="twitter:card"]', "name", "twitter:card", "summary_large_image");
  setMeta('meta[name="twitter:title"]', "name", "twitter:title", config.title);
  setMeta('meta[name="twitter:description"]', "name", "twitter:description", config.description);
  setMeta('meta[name="twitter:image"]', "name", "twitter:image", image);
  let canonical = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]');
  if (!canonical) {
    canonical = document.createElement("link");
    canonical.rel = "canonical";
    document.head.append(canonical);
  }
  canonical.href = config.canonical;
  let script = document.head.querySelector<HTMLScriptElement>("#route-structured-data");
  if (!script) {
    script = document.createElement("script");
    script.id = "route-structured-data";
    script.type = "application/ld+json";
    document.head.append(script);
  }
  script.textContent = JSON.stringify(config.structuredData ?? []);
}
